module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/incense_990599.jpg";